import axios from 'axios'

const baseURL = process.env.VUE_APP_DROP_ORDER_SERVICE + '/api/admin/orders'

export default {
  namespaced: true,
  state: {
    order: null,
    favoriteOrders: localStorage.getItem('drop-favorite-orders') ? JSON.parse(localStorage.getItem('drop-favorite-orders')) : []
  },
  getters: {
    isFavorite: state => id => {
      return state.favoriteOrders.findIndex(item => item.id === id) !== -1
    }
  },
  mutations: {
    setOrder (state, payload) {
      state.order = payload
    },
    addFavoriteOrder (state, order) {
      state.favoriteOrders.push({
        id: order.id,
        number: order.number,
        client: order.client,
        total: order.total,
        user_name: order.user ? order.user.name : null
      })
      localStorage.setItem('drop-favorite-orders', JSON.stringify(state.favoriteOrders))
    },
    deleteFavoriteOrder (state, order) {
      const index = state.favoriteOrders.findIndex(item => item.id === order.id)
      if (index !== -1) {
        state.favoriteOrders.splice(index, 1)
      }
      localStorage.setItem('drop-favorite-orders', JSON.stringify(state.favoriteOrders))
    }
  },
  actions: {
    async getOrders ({
      state,
      commit
    }, filters) {
      switch (parseInt(filters.sort)) {
        case 1:
          filters.order_by = 'created_at'
          filters.order_direction = 'asc'
          break
        case 2:
          filters.order_by = 'created_at'
          filters.order_direction = 'desc'
          break
      }
      return axios.get(baseURL, {
        params: filters
      })
    },
    async getOrder ({
      state,
      commit
    }, id) {
      return axios.get(baseURL + '/' + id)
    },
    async updateOrder ({ state, commit }, data) {
      return axios.put(baseURL + '/' + data.id, data)
    },
    async updateOrderStatuses ({ state, commit }, data) {
      return axios.put(baseURL + '/' + data.id + '/statuses', data)
    },
    async createEN ({ state, commit }, id) {
      return axios.post(baseURL + '/' + id + '/create-en')
    },
    async tracking ({ state, commit }, id) {
      return axios.post(baseURL + '/' + id + '/tracking')
    },
    async cancelOrder ({ state, commit }, data) {
      return axios.delete(baseURL + '/' + data.id, {
        data: data
      })
    },
    async updateProducts ({ state }, data) {
      return axios.put(baseURL + '/' + data.order_id + '/update-products', data)
    },
    async addProduct ({ state }, data) {
      return axios.put(baseURL + '/' + data.order_id + '/add-product', data)
    },
    async getLogs ({
      state,
      commit
    }, data) {
      return axios.get(baseURL + '/' + data.id + '/logs', {
        params: data
      })
    }
  }
}
